type StartupErrorProps = {
  details?: string;
};

export function StartupError({ details }: StartupErrorProps) {
  return (
    <main className="login-shell" role="alert">
      <section className="login-card">
        <div className="brand-mark">FC</div>
        <p className="eyebrow">Startup configuration error</p>
        <h1>SS Core cannot start safely</h1>
        <p className="login-copy">
          Required public Supabase environment configuration is missing or
          invalid. Configure the Vite environment before opening SS Core.
        </p>
        {details ? <p className="error-text">{details}</p> : null}
      </section>
    </main>
  );
}
